import { createSlice } from '@reduxjs/toolkit';
import config from '../../temp/config';

const initialState = {
  config,
  displayErrors: false,
  errorMessages: [],
  hasError: false,
  overlay: null,
  nextPage: null,
  prevPage: null,
  addOthers: false,
  othersToAdd: {
    spouse: false,
    children: false,
  },
  validPostcode: false,
  isModalOpen: false,
  preventPageUpdate: false,
  quoteRevalidation: {
    premiumChangeAlert: false,
    dependantInvalid: false,
    principalAgeInvalid: false,
  },
};

const AppStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setConfig: (state, action) => {
      return { ...state, config: action.payload };
    },
    setIsModalOpen: (state, action) => {
      return { ...state, isModalOpen: action.payload };
    },
    setOverlay: (state, action) => {
      return { ...state, overlay: action.payload };
    },
    setAddOthers: (state, action) => {
      return { ...state, addOthers: action.payload };
    },
    setAddSpouse: (state, action) => {
      return { ...state, othersToAdd: { ...state.othersToAdd, spouse: action.payload } };
    },
    setAddChildren: (state, action) => {
      return { ...state, othersToAdd: { ...state.othersToAdd, children: action.payload } };
    },
    setConfirmStatement: (state, action) => {
      return { ...state, confirmStatement: action.payload };
    },
    setHealthDeclaration: (state, action) => {
      return { ...state, healthDeclaration: action.payload };
    },
    showErrors: state => {
      return { ...state, displayErrors: true };
    },
    setNextPage: (state, action) => {
      return { ...state, nextPage: action.payload };
    },
    setPrevPage: (state, action) => {
      return { ...state, prevPage: action.payload };
    },

    setPreventPageUpdate: (state, action) => {
      return { ...state, preventPageUpdate: action.payload };
    },

    setRetrieveQuoteNumber: (state, action) => {
      return { ...state, retrieveQuoteNumber: action.payload };
    },
    setRetrieveQuoteDob: (state, action) => {
      return { ...state, retrieveQuoteDob: action.payload };
    },
    addErrorMessage: (state, action) => {
      if (action.payload.message !== undefined) {
        if (state.errorMessages.find(e => action.payload.uid === e.uid)) {
          return {
            ...state,
            errorMessages: state.errorMessages.map(e =>
              e.uid === action.payload.uid ? action.payload : e
            ),
            hasError: true,
          };
        }

        return {
          ...state,
          errorMessages: [...state.errorMessages, action.payload],
          hasError: true,
        };
      }
    },
    removeErrorMessage: (state, action) => {
      const newErrorMessages = state.errorMessages.filter(e => action.payload !== e.uid);
      return {
        ...state,
        errorMessages: newErrorMessages,
        hasError: newErrorMessages.length > 0,
      };
    },
    resetErrors: state => {
      return {
        ...state,
        errorMessages: [],
        hasError: false,
        displayErrors: false,
      };
    },

    setIsValidPostcode: (state, action) => {
      return { ...state, validPostcode: action.payload };
    },
    setQuoteRevalidation: (state, action) => {
      return {
        ...state,
        quoteRevalidation: { ...state.quoteRevalidation, ...action.payload },
      };
    },
    resetQuoteRevalidation: state => {
      return { ...state, quoteRevalidation: initialState.quoteRevalidation };
    },
    resetAppState: () => initialState,
  },
});

export const {
  setConfig,
  setOverlay,
  setNextPage,
  setPrevPage,
  showErrors,
  resetErrors,
  addErrorMessage,
  removeErrorMessage,
  updateErrorMessage,
  resetAppState,
  setAddOthers,
  setAddSpouse,
  setAddChildren,
  setIsValidPostcode,
  setIsModalOpen,
  setPreventPageUpdate,
  setQuoteRevalidation,
  resetQuoteRevalidation,
} = AppStateSlice.actions;

export default AppStateSlice.reducer;
